"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.localize = exports.init = exports.Localize = void 0;
const fs = require("fs");
const path = require("path");
const vscode = require("vscode");
class Localize {
    constructor(options = {}) {
        this.options = options;
    }
    /**
     * translate the key
     * @param key
     * @param args
     */
    localize(key, ...args) {
        const languagePack = this.bundle;
        const message = languagePack[key] || key;
        return this.format(message, args);
    }
    init(extensionPath) {
        this.extensionPath = extensionPath;
        this.bundle = this.resolveLanguagePack();
    }
    format(message, args = []) {
        let result;
        if (args.length === 0) {
            result = message;
        }
        else {
            result = message.replace(/\{(\d+)\}/g, (match, rest) => {
                const index = rest[0];
                return typeof args[index] !== "undefined" ? args[index] : match;
            });
        }
        return result;
    }
    resolveLanguagePack() {
        const defaultResolvedLanguage = ".nls.json";
        let resolvedLanguage = "";
        const rootPath = this.extensionPath || process.cwd();
        const file = path.join(rootPath, "package");
        const options = this.options;
        if (!options.locale) {
            resolvedLanguage = defaultResolvedLanguage;
        }
        else {
            let locale = options.locale;
            while (locale) {
                const candidate = ".nls." + locale + ".json";
                if (fs.existsSync(file + candidate)) {
                    resolvedLanguage = candidate;
                    break;
                }
                else {
                    const index = locale.lastIndexOf("-");
                    if (index > 0) {
                        locale = locale.substring(0, index);
                    }
                    else {
                        resolvedLanguage = ".nls.json";
                        locale = null;
                    }
                }
            }
        }
        let defaultLanguageBundle = {};
        // if not use default language
        // then merger the Language pack
        // just in case the resolveLanguage bundle missing the translation and fallback with default language
        if (resolvedLanguage !== defaultResolvedLanguage) {
            defaultLanguageBundle = JSON.parse(fs.readFileSync(path.join(file + defaultResolvedLanguage), "utf8"));
        }
        const languageFilePath = path.join(file + resolvedLanguage);
        const isExistResolvedLanguage = fs.existsSync(languageFilePath);
        const ResolvedLanguageBundle = isExistResolvedLanguage ? JSON.parse(fs.readFileSync(languageFilePath, "utf8")) : {};
        // merger with default language bundle
        return Object.assign(Object.assign({}, defaultLanguageBundle), ResolvedLanguageBundle);
    }
}
exports.Localize = Localize;
let config = {
    locale: vscode.env.language,
};
const instance = new Localize(config);
function init(extensionPath) {
    return instance.init(extensionPath);
}
exports.init = init;
function localize(key, ...args) {
    return instance.localize(key, ...args);
}
exports.localize = localize;
//# sourceMappingURL=index.js.map